<template>
    <div :id='"qrcode"+mark'></div>
</template>
<script>
  import QRCode from "qrcodejs2";
  export default{
     components: { QRCode },
     mounted () {
        this.$nextTick(function () {
           this.qrcode();
        });
     },
     props:{
        mark:{
            type: String,
			default: () => '1'
        }
     },
     methods: {
         qrcode () {
             new QRCode("qrcode"+this.mark, {
                width:30,
                height:30,
                text: "20",
            });
         }
     }
  }
</script>
<style>
</style>